// Verbrauch im Tarif mit Grenze (Kostenlos): „3 von 5 Rechnungen diesen Monat“. Platziert vom Rechnungswerkzeug
// (rechnung/Uebersicht, RechnungList, RechnungForm). Übersicht: ab 60 % einer Grenze; Liste: kurze Zeile hinter der
// Anzahl; Formular: nur wenn die Grenze erreicht ist oder noch eine Rechnung frei ist. Ohne Grenze (Start, Pro, Test)
// und ohne Tarif (Kanzlei) nichts.
import { Link } from 'react-router-dom';
import { naechsterMonat } from './anzeige';
import type { Tarif } from './types';
import { planName } from './upgrade';
import './hinweise.css';

type Art = 'rechnungenMonat' | 'angeboteMonat';
const WORT: Record<Art, [string, string]> = { rechnungenMonat: ['Rechnung', 'Rechnungen'], angeboteMonat: ['Angebot', 'Angebote'] };

// kleinster Tarif ohne diese Grenze
function abPlan(tarif: Tarif, art: Art) {
  return tarif.tarife.find((t) => t.id !== 'kostenlos' && t.grenzen[art] === null);
}

export function NutzungHinweis({ tarif, wo }: { tarif: Tarif | null | undefined; wo: 'uebersicht' | 'liste' | 'formular' }) {
  if (!tarif) return null;
  const stand = (art: Art) => {
    const limit = tarif.grenzen[art];
    return limit === null ? null : { art, limit, n: Math.min(tarif.nutzung[art], limit) };
  };

  if (wo === 'liste') {
    const r = stand('rechnungenMonat');
    if (!r) return null;
    return (
      <span className="bt-nutzung-zeile">
        {' '}
        · {r.n} von {r.limit} diesen Monat
      </span>
    );
  }

  const arten: Art[] = wo === 'formular' ? ['rechnungenMonat'] : ['rechnungenMonat', 'angeboteMonat'];
  const zeigen = arten
    .map(stand)
    .filter((s): s is NonNullable<typeof s> => !!s)
    .filter((s) => (wo === 'formular' ? s.n >= s.limit - 1 : s.n >= Math.ceil(s.limit * 0.6)));
  if (!zeigen.length) return null;
  // die vollere Grenze zuerst
  const s = zeigen.sort((a, b) => b.n / b.limit - a.n / a.limit)[0]!;
  const [eins, viele] = WORT[s.art];
  const voll = s.n >= s.limit;
  const ab = abPlan(tarif, s.art);
  const tarifName = planName(tarif, tarif.effektiv);
  const text = voll
    ? `Im Tarif ${tarifName} sind ${s.limit} ${s.limit === 1 ? eins : viele} im Monat enthalten, diesen Monat sind alle geschrieben. Am ${naechsterMonat()} geht es weiter${ab ? `, mit ${ab.name} sofort und unbegrenzt` : ''}.`
    : s.limit - s.n === 1
      ? `Noch 1 ${eins} frei in diesem Monat (${s.n} von ${s.limit}).`
      : `${s.n} von ${s.limit} ${viele} in diesem Monat geschrieben.`;
  return (
    <div className={`notice ${voll ? 'warn' : 'info'} bt-nutzung`} role={wo === 'formular' && voll ? 'status' : undefined}>
      <div className="bt-nutzung-text">
        <span>{text}</span>
        <span className="bt-balken" aria-hidden="true">
          <i style={{ width: `${(s.n / s.limit) * 100}%` }} />
        </span>
      </div>
      {ab && (
        <Link className="btn small" to={`/rechnung/tarif?plan=${ab.id}`}>
          {voll ? `${ab.name} ansehen` : 'Tarife ansehen'}
        </Link>
      )}
    </div>
  );
}
